module.exports = __webpack_public_path__ + "static/media/TouchflowPC for iOS.86c943b2.msi";